import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { pathalogyColumns } from "./pathalogyColumns";

const PathalogyTable = ({ pathlogyList, handleGetRowId, actionColumn }) => {
    
    return (
        <>
            <DataGrid
                autoHeight
                rows={pathlogyList?.length > 0 ? pathlogyList : []}
                loading={pathlogyList?.length > 0 || pathlogyList === null ? false : false}
                columns={pathalogyColumns.concat(actionColumn)}
                pageSize={10}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                getRowId={handleGetRowId}
                checkboxSelection={false} />

        </>
    )
}

export default PathalogyTable;